module.exports = __webpack_public_path__ + "static/media/sunny house design.7cffd256.webp";